export default __webpack_public_path__ + "static/media/foodtruck_mobile.8213f479.jpg";